import './App.css';
import { useState} from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from "./Login/Login";
import Ingreso from './Ingreso/Ingreso';
import Formato from './Formato/Formato';
import Protected from './Protected';
import Confirmacion from './Confirmacion/Confirmacion';
import Logged from './Logged/Logged';
import Revision from './Revision/Revision';
import Vista from './Vista/Vista';
import Layout from './Layout';

function App() {
  const [state,setState] = useState({data: []})
  const [ sesionUser, setSesionUser ] = useState("")

  const handleDataReceived = (datos) => {
    setState({ data: datos});
  };

  const handleDataReceivedSesion = (usuario) => {
    setSesionUser(usuario);
  };

  function stringify(obj) {
    let cache = [];
    let str = JSON.stringify(obj, function(key, value) {
    if (typeof value === "object" && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Circular reference found, discard key
            return;
        }
        // Store value in our collection
        cache.push(value);
    }
    return value;
    });
    cache = null; // reset the cache
    return str;
  }

  console.log(state.data)

  return (
    <div className='App'>
      <BrowserRouter basename="/mantenimiento">
        <Routes>
          <Route path="/" 
          element={<Layout>
            <Login 
              sesionUser={sesionUser} 
              handleDataReceivedSesion={handleDataReceivedSesion}
            />
          </Layout>} />

          <Route 
            path="/ingreso" 
            element={<Layout>
              <Protected 
              stringify={stringify} 
              handleDataReceived={handleDataReceived}
              formatoData={state.data}
              Component={state.data.revisar ? Revision:(state.data.vista ? Vista:(state.data.ingreso ? Ingreso:(state.data.formato ? Formato:(state.data.ingresoData ? Confirmacion:Logged))))}
              />
            </Layout>}
            
          />
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
